import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="bg-black text-white min-h-screen flex items-center justify-center px-4">
      <Helmet>
        <title>404 — Page Not Found | 210 Tattoo Athens</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <div className="text-center max-w-md">
        <p className="text-pink-500 text-8xl font-bold mb-4">404</p>
        <h1 className="text-3xl font-bold text-white mb-4">Page Not Found</h1>
        <p className="text-gray-400 mb-8">
          The page you are looking for does not exist or has been moved.
        </p>
        <Link
          to="/"
          className="bg-gradient-to-r from-pink-600 to-pink-700 hover:from-pink-700 hover:to-pink-800 px-8 py-3 rounded-lg font-semibold transition-all duration-300 inline-block"
        >
          Back to Home
        </Link>
      </div>
    </div>
  );
}
